export default __webpack_public_path__ + "static/media/hibiscus.d44187bd.png";